// src/api/dashboard/index.js
import { http } from "../base"

export async function getOverviewMetrics(params) {
    try {
        const response = await http.get('/aics/dashboard/overview', { params })
        return response
    } catch (error) {
        return error
    }
}

export async function getTrafficTrend(params) {
    console.log("getTrafficTrend 参数:", params)
    try {
        const formData = new URLSearchParams()
        formData.append('tenantId', params.tenantId)
        formData.append('startTime', params.startTime)
        formData.append('endTime', params.endTime)
        formData.append('timeGroupBy', params.timeGroupBy || 'DAY')
        
        const response = await http.post('/aics/dashboard/traffic-trend', formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        return response
    } catch (error) {
        return error
    }
}

export async function getFeedbackDetail(params) {
    console.log("getFeedbackDetail 参数:", params)
    try {
        const response = await http.post('/statistics/feedback-detail', params)
        return response
    } catch (error) {
        return error
    }
}
/*
export async function getKnowledgePerformance(params) {
    console.log("getKnowledgePerformance 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/knowledge-performance', params)
        return response
    } catch (error) {
        return error
    }
}*/

/**
 * 获取未知问题TOP榜
 * @param {Object} params - 请求参数
 * @param {number} params.tenantId - 租户ID
 * @param {string} params.startTime - 开始时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.endTime - 结束时间 (yyyy-MM-dd HH:mm:ss)
 * @param {number} [params.page] - 页码，从0开始
 * @param {number} [params.size] - 每页条数
 * @param {string} [params.keyword] - 搜索关键词（可选）
 * @param {string} [params.workspaceSlug] - 工作区标识（可选）
 * @returns {Promise} 响应结果
 */
export async function getTopUnknownQuestions(params) {
    console.log("getTopUnknownQuestions 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/top-unknown', params)
        return response
    } catch (error) {
        return error
    }
}

/**
 * 获取会话汇总列表
 * @param {Object} params - 请求参数
 * @param {number} params.tenantId - 租户ID
 * @param {string} params.startTime - 开始时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.endTime - 结束时间 (yyyy-MM-dd HH:mm:ss)
 * @param {number} params.page - 页码，从0开始
 * @param {number} params.size - 每页条数
 * @param {string} params.keyword - 搜索关键词（可选）
 * @param {string} params.workspaceSlug - 工作区标识（可选）
 * @returns {Promise} 响应结果
 */
export async function getConversationList(params) {
    console.log("getConversationList 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/conversation-list', params)
        return response
    } catch (error) {
        return error
    }
}

/**
 * 获取会话详情（完整对话消息列表）
 * @param {number} conversationId - 会话ID
 * @param {number} tenantId - 租户ID
 * @returns {Promise} 响应结果
 */
export async function getConversationDetail(conversationId, tenantId) {
    console.log("getConversationDetail 参数:", { conversationId, tenantId })
    try {
        const response = await http.get(`/aics/dashboard/conversation-detail/${conversationId}`, {
            params: { tenantId }
        })
        return response
    } catch (error) {
        return error
    }
}


/**
 * 获取近7日咨询量趋势
 * @param {number} tenantId - 租户ID
 */
export async function getConversationTrend(tenantId) {
    try {
        const response = await http.get('/aics/dashboard/conversation-trend', { 
            params: { tenantId } 
        })
        return response
    } catch (error) {
        return error
    }
}

/**
 * 获取问题分类统计
 * @param {number} tenantId - 租户ID
 */
export async function getIntentStatistics(tenantId) {
    try {
        const response = await http.get('/aics/dashboard/intent-statistics', { 
            params: { tenantId } 
        })
        return response
    } catch (error) {
        return error
    }
}

/**
 * 获取知识库文档表现报表
 * @param {Object} params - 请求参数
 * @param {number} params.tenantId - 租户ID
 * @param {string} params.startTime - 开始时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.endTime - 结束时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.documentType - 文档类型 DOC/QA（可选）
 * @param {string} params.keyword - 文档标题关键词（可选）
 * @param {number} params.page - 页码，从0开始
 * @param {number} params.size - 每页条数
 * @param {string} params.sortField - 排序字段
 * @param {string} params.sortDirection - 排序方向
 * @returns {Promise} 响应结果
 */
export async function getKnowledgePerformance(params) {
    console.log("getKnowledgePerformance 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/knowledge-performance', params)
        return response
    } catch (error) {
        return error
    }
}


/**
 * 获取热门搜索与命中分析列表
 * @param {Object} params - 请求参数
 * @param {number} params.tenantId - 租户ID
 * @param {string} params.startTime - 开始时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.endTime - 结束时间 (yyyy-MM-dd HH:mm:ss)
 * @param {string} params.workspaceSlug - 工作区标识（可选）
 * @param {number} params.isHit - 命中状态（1-命中，0-未命中，null-全部）
 * @param {string} params.keyword - 搜索关键词（可选）
 * @param {number} params.minSearchCount - 最低搜索次数，默认2
 * @param {number} params.topN - 返回Top N，默认20
 * @param {number} params.page - 页码，从0开始
 * @param {number} params.size - 每页条数
 * @returns {Promise} 响应结果
 */
export async function getHotSearchList(params) {
    console.log("getHotSearchList 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/hot-search', params)
        return response
    } catch (error) {
        return error
    }
}


/**
 * 导出热门搜索与命中分析数据
 * @param {Object} params - 请求参数（与查询接口相同）
 * @returns {Promise} 响应结果（文件流）
 */
export async function exportHotSearch(params) {
    console.log("exportHotSearch 参数:", params)
    try {
        const response = await http.post('/aics/dashboard/hot-search/export', params, {
            responseType: 'blob'  // 重要：指定响应类型为blob
        })
        return response
    } catch (error) {
        return error
    }
}
